import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";

require("../../desktop/styles/statute-outline.less");
const template = require<string>("../../desktop/views/statute-outline.html");

const dom = {
    STATUTE_OUTLINE_BTN: ".btn-statute-outline",
    STATUTE_OUTLINE_BTN_LABEL: ".btn-statute-outline .statute-outline-selected",
    STATUTE_OUTLINE_BTN_GROUP: ".btn-group",
    STATUTE_OUTLINE_ITEM: ".section a",
    DOCUMENT_LINKS: ".document-link",
    STATUTE_OUTLINE_TEMPLATE: "#statute-outline-item-template",
    ACTIVE_LINK: "li.active"
};

@backboneViewProperties({
    tagName: "div",
    template
})
export class StatuteOutlineView extends Marionette.ItemView<Backbone.Model> {

    constructor(options?: Backbone.ViewOptions<Backbone.Model>) {
        super(options);
    }

    public onShow() {
        this.highlightActiveItem();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click ${dom.DOCUMENT_LINKS}`] = this.documentLinkClick;

        if (navigator.userAgent.match(/chrome/i)) {
            $("body").on("click", dom.STATUTE_OUTLINE_BTN, () => {
                _.defer(() => {
                    this.highlightActiveItem();
                });
            });
        } else {  // this fix allows scrolling to the selected item in IE and firefox.
            $("body").on("click", (e) => {
                if ($(e.target).hasClass("btn-statute-outline")) {
                    _.defer(() => {
                        this.highlightActiveItem();
                    });
                }
            });
        }
        return events;
    }

    public setActiveSection(activeSection: string) {
        this.$(dom.ACTIVE_LINK).removeClass("active");
        const $activeParent = this.$(`a[data-id="${activeSection}"]`).parents("li").first();
        const buttonText = $activeParent.text().length <= 43 ? $activeParent.text() : $activeParent.text().substr(0, 41) + "...";
        const $buttonLabel = $activeParent.closest(dom.STATUTE_OUTLINE_BTN_GROUP).find(dom.STATUTE_OUTLINE_BTN_LABEL);
        $buttonLabel.html(buttonText);
        $activeParent.addClass("active");
    }

    private highlightActiveItem() {

        const outlineGroup = this.$el.closest(dom.STATUTE_OUTLINE_BTN_GROUP);
        if (!outlineGroup.hasClass("open")) {
            return;
        }

        // get label text
        const selectedItemText = outlineGroup.find(dom.STATUTE_OUTLINE_BTN_LABEL).text().trim()
            .replace(/^(Schedule)\s(\d+):(.+$)/i, "$2.$3")  // if label starts with schedule, then remove it
            .replace(/\.{3}$/, ""); // remove ellipsis

        if (!selectedItemText) {
            return;
        }

        // find section label that matches
        const regex = new RegExp("^" + this.escapeRegExp(selectedItemText));

        const targetListItem = this.$el.find("a")
            .filter((el) => {
                return regex.test($(el).parent().text());
            });

        if (targetListItem.length === 0) {
            return;
        }

        targetListItem.addClass("selected");
        outlineGroup.find(".statute-outline-list").scrollTo(targetListItem, 300, { offset: -45 });
    }

    private documentLinkClick(e: JQueryEventObject) {
        const $item = $(e.currentTarget);
        $item.parents(".btn-group").removeClass("open");
        const id = $item.attr("data-id");
        this.setActiveSection(id);
        (e.originalEvent as any).preserveSection = true;
    }

    private escapeRegExp(str: string) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/statute-outline.ts